import { render, staticRenderFns } from "./ModalRedeem.vue?vue&type=template&id=28d546d0&"
import script from "./ModalRedeem.vue?vue&type=script&lang=js&"
export * from "./ModalRedeem.vue?vue&type=script&lang=js&"
import style0 from "./ModalRedeem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports